
export default {
  props: {
    priorityCampaign: { type: Object, default: () => {} },
    maxDiscount: { type: [Number, String], default: -Infinity },
    compareAtPrice: { type: String, default: "" },
  },

  computed: {
    saleTitleHtml() {
      const html = this.$prismic.asHtml(this.priorityCampaign?.pdpSaleTitle);
      return this.maxDiscount
        ? html.replace(/__percentage__/g, this.maxDiscount)
        : html;
    },
    saleBody() {
      return this.priorityCampaign?.pdpSaleBody;
    },
  },
};
